import { openCustomerFeedback } from '@/components/mainApply/sceneResearch';

export function showUserVoice(sceneId: any) {
  if (!sceneId) return;
  openCustomerFeedback({
    sceneId, // 问卷ID
    loginType: 7, // 商家端：3， 采销端：7
  });
}
